export default __webpack_public_path__ + "static/media/AVISO_DE_PRIVACIDAD_CLIENTES.0de3c84a.pdf";